import { gql } from 'react-apollo';

export const resetPassword = gql`
  mutation resetPassword($input: ResetPasswordInput!) {
    resetPassword(input: $input) {
      isNewPassword: new_password
      user {
        id
        type
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/reset_password/mutations/resetPassword.js